import { GET_BANKBRANCH, GET_BANKBRANCH_SUCCESS, GET_BANKBRANCH_FAIL, DELETE_BANKBRANCH, DELETE_BANKBRANCH_SUCCESS, DELETE_BANKBRANCH_FAIL, UPDATE_BANKBRANCH, UPDATE_BANKBRANCH_SUCCESS, UPDATE_BANKBRANCH_FAIL, ADD_NEW_BANKBRANCH, ADD_BANKBRANCH_SUCCESS, ADD_BANKBRANCH_FAIL, BANKBRANCH_LOADING, BANKBRANCH_RESET } from "./actionType";

export const resetBankBranchState = (actionType) => ({
  type: BANKBRANCH_RESET,
  payload: { actionType },
});

export const getBankBranchSuccess = (actionType, data) => {
  return {
    type: GET_BANKBRANCH_SUCCESS,
    payload: { actionType, data },
  };
};

export const getBankBranchFail = (actionType, error) => {
  return {
    type: GET_BANKBRANCH_FAIL,
    payload: { actionType, error },
  };
};

export const getBankBranch = (data) => ({
  type: GET_BANKBRANCH,
  payload: data,
});

export const getBankBranchLoading = () => ({
  type: BANKBRANCH_LOADING,
});

export const deleteBankBranch = (data) => ({
  type: DELETE_BANKBRANCH,
  payload: data,
});

export const deleteBankBranchSuccess = (data) => ({
  type: DELETE_BANKBRANCH_SUCCESS,
  payload: data,
});

export const deleteBankBranchFail = (error) => ({
  type: DELETE_BANKBRANCH_FAIL,
  payload: error,
});

export const updateBankBranch = (data) => ({
  type: UPDATE_BANKBRANCH,
  payload: data,
});

export const updateBankBranchFail = (error) => ({
  type: UPDATE_BANKBRANCH_FAIL,
  payload: error,
});

export const updateBankBranchSuccess = (data) => ({
  type: UPDATE_BANKBRANCH_SUCCESS,
  payload: data,
});

export const addNewBankBranch = (data) => ({
  type: ADD_NEW_BANKBRANCH,
  payload: data,
});

export const addBankBranchSuccess = (data) => ({
  type: ADD_BANKBRANCH_SUCCESS,
  payload: data,
});

export const addBankBranchFail = (error) => ({
  type: ADD_BANKBRANCH_FAIL,
  payload: error,
});
